var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "25px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "star / neon green") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star-/-neon-green",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-35-Copy-9",
    x: -1.77635684e-15,
    y: -1.77635684e-15,
    width: 25,
    height: 25
  }), /*#__PURE__*/React.createElement("g", {
    id: "star",
    transform: "translate(2.000000, 2.000000)",
    fill: "#00FFAF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8107688,7.79529918 C20.5684038,7.07286488 19.950839,6.55317827 19.198109,6.43898704 L14.4277122,5.70956143 L12.2930353,1.16521662 C12.1229137,0.801669034 11.8525835,0.501043146 11.5100098,0.293634588 C11.1954013,0.102539062 10.8318537,0.00233043324 10.4636452,0.00233043324 C10.0931064,0.00233043324 9.7318892,0.102539062 9.41728072,0.293634588 C9.07470703,0.501043146 8.80437678,0.801669034 8.63425515,1.16521662 L6.4995783,5.70956143 L1.72918146,6.43898704 C0.976451527,6.55317827 0.358886719,7.07286488 0.116521662,7.79529918 C-0.125843395,8.51773349 0.0559303977,9.30308949 0.587269176,9.84841087 L4.09923207,13.4489302 L3.26959783,18.5292747 C3.17405007,19.1165439 3.33951083,19.7108043 3.72403232,20.1629084 C4.11088423,20.6173429 4.67251864,20.8783514 5.26677912,20.8783514 C5.60702237,20.8783514 5.94493519,20.7897949 6.24556108,20.6243342 L10.4636452,18.2939009 L14.6817294,20.6266646 C14.9823553,20.7921254 15.3202681,20.8806818 15.6605114,20.8806818 C16.2547718,20.8806818 16.8164062,20.6196733 17.2032582,20.1652388 C17.5877797,19.7131348 17.7532404,19.1188743 17.6576926,18.5316051 L16.8280584,13.4512607 L20.3400213,9.8507413 C20.8713601,9.30541992 21.0508034,8.51773349 20.8107688,7.79529918 Z",
    id: "Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon_star.b547eb878accd5489c80c6ea7a4e2c5f.svg";
export { ForwardRef as ReactComponent };